import Confirmation from '@/components/Confirmation';
import type { Confirmation as ConfirmationInterface } from '@/components/Confirmation/types';
import usePreservedCallback from './react/usePreservedCallback';
import { useTunnel } from './tunnel/TunnelProvider';

type PropTypes = ConfirmationInterface.Input & {
  confirmTitle?: string;
};

export default function useAlert() {
  const tunnel = useTunnel();

  return usePreservedCallback(
    (props: PropTypes): Promise<boolean> =>
      new Promise((resolve) =>
        tunnel(({ close }) => {
          const confirm = {
            title: props.confirmTitle ?? '확인',
            highlight: true,
            handler: () => {
              resolve(true);
              close();
            },
          };

          return <Confirmation {...props} actions={[confirm]} />;
        }),
      ),
  );
}
